import { PayloadAction } from '@reduxjs/toolkit';
import { Annotation } from '@api/domain/types/annotations';
import { AnnotationsState } from '@reducers/v2/annotationsV2/annotationsV2.slice';

export const setAnnotationsForPageAction = (
  state: AnnotationsState,
  action: PayloadAction<{ documentId: number; pageNumber: number; annotations: Annotation[] }>
) => {
  const { documentId, pageNumber, annotations } = action.payload;
  if (!state.byDocument[documentId]) {
    state.byDocument[documentId] = {};
  }
  state.byDocument[documentId][pageNumber] = annotations;
};
